import { render, staticRenderFns } from "./Squard.vue?vue&type=template&id=1f08e645&scoped=true&"
import script from "./Squard.vue?vue&type=script&lang=js&"
export * from "./Squard.vue?vue&type=script&lang=js&"
import style0 from "./Squard.vue?vue&type=style&index=0&id=1f08e645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08e645",
  null
  
)

export default component.exports